class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    // If search params contains cart-open, open the cart drawer
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('cart-open')) {
      const cartLink = document.querySelector('#cart-icon-bubble');
      this.open(cartLink);
    }

    this.drawerAnimation = new DrawerAnimation(
      this,
      this.querySelector('.drawer__inner'),
      {
        type: 'drawer',
        drawerPosition: 'right',
        onOpen: () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);

          this.header.classList.add('header--has-scrolled');
        },
        onClose: () => {
          removeTrapFocus(this.activeElement);

          const headerWrapper = document.querySelector('.section-header');
          if (!headerWrapper.classList.contains('scrolled-past-header')) {
            this.header.classList.remove('header--has-scrolled');
          }
        }
      }
    );
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // Use the drawer animation utility
    if (this.drawerAnimation) {
      this.drawerAnimation.open();
    } else {
      // Fallback if animation isn't initialized yet
      this.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
      this.header.classList.add('header--has-scrolled');
    }
  }

  close() {
    // Use the drawer animation utility
    if (this.drawerAnimation) {
      this.drawerAnimation.close();
    } else {
      // Fallback if animation isn't initialized yet
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');

      const headerWrapper = document.querySelector('.section-header');
      if (!headerWrapper.classList.contains('scrolled-past-header')) {
        this.header.classList.remove('header--has-scrolled');
      }

      removeTrapFocus(this.activeElement);
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    window.Klarna?.OnsiteMessaging?.refresh();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: this.id,
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: this.id,
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
